<template>
  <!-- eslint-disable vue/max-len -->
  <div :class="$b()">
    <!-- LIFESTYLE SERIES OR SNOW -->
    <template v-if="isSnow || showLensGuideTabs">
      <div
        v-if="showLensTechSelect"
        :class="$b('row')"
      >
        <div :class="$b('item')">
          <BaseCopy
            size="body-sm"
            tag="div"
            :class="$b('item-title')"
          >
            {{ $tr('Material') }}
            <ToolTip
              arrow-position="left"
              :content="lensMaterialContent"
            />
          </BaseCopy>
          <BaseCopy
            size="h2"
            tag="div"
            :class="$b('item-value')"
          >
            {{ lensMaterial }}
          </BaseCopy>
        </div>
      </div>
      <div
        v-if="showLensTechSelect"
        :class="$b('row')"
      >
        <div
          v-if="showPrescriptionLensDetails && filterPrescription"
          :class="$b('item')"
        >
          <BaseCopy
            size="body-sm"
            tag="div"
            :class="$b('item-title')"
          >
            {{ $tr('Index') }}
            <ToolTip
              arrow-position="left"
              content="Index numbers reflect the thickness of a prescription lens. The higher the index number, the thinner your lens."
            />
          </BaseCopy>
          <BaseCopy
            size="h2"
            tag="div"
            :class="$b('item-value')"
          >
            {{ indexValue }}
          </BaseCopy>
        </div>
        <div
          v-else
          :class="$b('item')"
        >
          <BaseCopy
            size="body-sm"
            tag="div"
            :class="$b('item-title')"
          >
            {{ $tr('Abbe Value') }}
            <ToolTip
              arrow-position="left"
              content="Abbe Value is a measure of the optical clarity of a lens material. The higher the Abbe Value, the better the optical clarity of your lens."
            />
          </BaseCopy>
          <BaseCopy
            size="h2"
            tag="div"
            :class="$b('item-value')"
          >
            {{ abbeValue }}
          </BaseCopy>
        </div>
        <div :class="$b('item')">
          <BaseCopy
            size="body-sm"
            tag="div"
            :class="$b('item-title')"
          >
            {{ $tr('Polarised') }}
            <ToolTip
              arrow-position="right"
              content="Polarised lenses contain an invisible microfilter which cuts out glare. Colours appear brighter and bolder, and your eyes feel more relaxed."
            />
          </BaseCopy>
          <BaseCopy
            size="h2"
            tag="div"
            :class="$b('item-value')"
          >
            {{ $tr(isPolarised) }}
          </BaseCopy>
        </div>
      </div>
      <div
        v-else
        :class="$b('row')"
      >
        <div :class="$b('item')">
          <BaseCopy
            size="body-sm"
            tag="div"
            :class="$b('item-title')"
          >
            VLT
            <ToolTip
              arrow-position="left"
              content="VLT stands for Visible Light Transmission. It measures how much light passes through a lens to reach the eye. The lower the VLT, the darker the tint of your lenses."
            />
          </BaseCopy>
          <BaseCopy
            size="h2"
            tag="div"
            :class="$b('item-value')"
          >
            {{ selectedLensDetails.vlt }}%
          </BaseCopy>
        </div>
        <div :class="$b('item')">
          <BaseCopy
            size="body-sm"
            tag="div"
            :class="$b('item-title')"
          >
            {{ $tr('UV Protection') }}
            <ToolTip
              arrow-position="right"
              content="Your SunGods block 100% of UVA and UVB radiation, meeting UV400 safety standards. This means they protect your eyes from harmful ultraviolent (UV) solar radiation."
            />
          </BaseCopy>
          <BaseCopy
            size="h2"
            tag="div"
            :class="$b('item-value')"
          >
            {{ $tp(1, 0) }}
          </BaseCopy>
        </div>
      </div>
    </template>
    <!-- PACE SERIES -->
    <template v-else>
      <div :class="$b('row')">
        <div :class="$b('item')">
          <BaseCopy
            size="body-sm"
            tag="div"
            :class="$b('item-title')"
          >
            {{ $tr('Material') }}
            <ToolTip
              arrow-position="left"
              :content="lensMaterialContent"
            />
          </BaseCopy>
          <BaseCopy
            size="h2"
            tag="div"
            :class="$b('item-value')"
          >
            {{ lensMaterial }}
          </BaseCopy>
        </div>
        <div :class="$b('item', { showIrisPreview })">
          <BaseCopy
            size="body-sm"
            tag="div"
            :class="$b('item-title')"
          >
            VLT
            <ToolTip
              arrow-position="right"
              content="VLT stands for Visible Light Transmission. It measures how much light passes through a lens to reach the eye. The lower the VLT, the darker the tint of your lenses."
            />
          </BaseCopy>
          <!-- eslint-disable vue/no-v-html -->
          <BaseCopy
            size="h2"
            tag="div"
            :class="$b('item-value')"
          >
            <span v-html="vltValue" />
          </BaseCopy>
          <!-- eslint-enable vue/no-v-html -->
        </div>
      </div>
      <div :class="$b('row')">
        <div :class="$b('item')">
          <BaseCopy
            size="body-sm"
            tag="div"
            :class="$b('item-title')"
          >
            {{ $tr('Abbe Value') }}
            <ToolTip
              arrow-position="left"
              content="Abbe Value is a measure of the optical clarity of a lens material. The higher the Abbe Value, the better the optical clarity of your lens."
            />
          </BaseCopy>
          <BaseCopy
            size="h2"
            tag="div"
            :class="$b('item-value')"
          >
            {{ abbeValue }}
          </BaseCopy>
        </div>
        <div :class="$b('item')">
          <BaseCopy
            size="body-sm"
            tag="div"
            :class="$b('item-title')"
          >
            {{ $tr('UV Protection') }}
            <ToolTip
              arrow-position="right"
              content="Your SunGods block 100% of UVA and UVB radiation, meeting UV400 safety standards. This means they protect your eyes from harmful ultraviolent (UV) solar radiation."
            />
          </BaseCopy>
          <BaseCopy
            size="h2"
            tag="div"
            :class="$b('item-value')"
          >
            {{ $tp(1, 0) }}
          </BaseCopy>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'LensTechData',
  props: {
    currentTab: {
      type: String,
      default: '',
    },
    hasLensTechFiltering: {
      type: Boolean,
      default: false,
    },
    irisToggleActive: {
      type: Boolean,
      default: false,
    },
    isIris: {
      type: Boolean,
      default: false,
    },
    lensTech: {
      type: String,
      default: '',
    },
    selectedLensDetails: {
      type: Object,
      default: () => {},
    },
    lensTechSelected: {
      type: Boolean,
      required: true,
    },
    showIrisPreview: {
      type: Boolean,
      default: false,
    },
    showLensGuideTabs: {
      type: Boolean,
      default: false,
    },
    showLensTechSelect: {
      type: Boolean,
      default: false,
    },
    showPrescriptionLensDetails: {
      type: Boolean,
      default: false,
    },
    filterPrescription: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['lens-tech-selected'],
  computed: {
    lensMaterial() {
      if (!this.lensTechSelected && this.hasLensTechFiltering) return '-'
      if (this.showPrescriptionLensDetails && this.filterPrescription)
        return 'CR39'
      return this.lensTech.includes('4ko') ? 'Polycarbonate' : 'Nylon'
    },
    lensMaterialContent() {
      if (!this.lensTechSelected && this.hasLensTechFiltering) return ''
      if (this.showPrescriptionLensDetails && this.filterPrescription)
        return 'SunGod prescription lenses are precision-engineered from CR39, featuring market-leading clarity, 100% UV and impact protection, and a triple-layer scratch-resistant coating.'
      if (this.lensMaterial === 'Nylon') {
        return "SunGod 8KO<sup>&reg;</sup> lenses are precisely engineered from 2mm nylon. This material has all the benefits of our original lens technology, plus it's lighter, clearer and stronger."
      }
      return 'SunGod standard lenses are precisely engineered from 2mm polycarbonate. This is our original lens technology, and features a triple-layer scratch-resistant coating and certified impact protection.'
    },
    abbeValue() {
      if (!this.lensTechSelected && this.hasLensTechFiltering) return '-'
      return this.lensTech.includes('4ko') ? '31' : '45'
    },
    indexValue() {
      if (!this.lensTechSelected && this.hasLensTechFiltering) return '-'
      return this.lensTech.includes('4ko') ? '1.50' : '1.67'
    },
    irisLowerValue() {
      if (!this.isIris) return null
      return this.selectedLensDetails.vlt.split('-')[0]
    },
    irisUpperValue() {
      if (!this.isIris) return null
      return this.selectedLensDetails.vlt.split('-')[1]
    },
    vltValue() {
      if (this.isIris)
        return `<span class="${this.$b('vlt-lower')}">${
          this.irisLowerValue
        }%</span>-<span class="${this.$b('vlt-upper')}">${
          this.irisUpperValue
        }%</span>`
      return `${this.selectedLensDetails.vlt}%`
    },
    isPolarised() {
      if (!this.lensTechSelected && this.hasLensTechFiltering) return '-'
      return this.lensTech.includes('kop') ? 'Yes' : 'No'
    },
    isSnow() {
      return this.lensTech.includes('snow')
    },
  },
  watch: {
    filterPrescription(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$emit('lens-tech-selected', newValue)
      }
    },
  },
}
</script>

<style lang="postcss">
.LensTechData {
  @apply pt-xs md:pt-sm mt-auto mb-0;

  max-width: 460px;
}

.LensTechData__row {
  @apply flex justify-between;

  + .LensTechData__row {
    @apply pt-xs md:pt-sm;
  }
}

.LensTechData__item {
  @apply whitespace-nowrap;
  flex: 0 0 130px;
  font-variant-numeric: tabular-nums;

  @screen md {
    flex: 0 0 155px;
  }

  .LensTechData__vlt-lower {
    @apply opacity-30;
    transition: opacity 0.2s ease-in-out;
  }

  .LensTechData__vlt-upper {
    @apply opacity-100;
    transition: opacity 0.2s ease-in-out;
  }

  &--show-iris-preview {
    .LensTechData__vlt-lower {
      @apply opacity-100;
    }

    .LensTechData__vlt-upper {
      @apply opacity-30;
    }
  }

  .LensTechData__item-title {
    @apply flex items-center;
    font-size: 12px;
    line-height: 1.4;
  }
}
</style>
